import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useStyles } from './EmptyState.styles'

interface EmptyStateProps {
  searchTerm?: string
}

const EmptyState = ({ searchTerm }: EmptyStateProps) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Box className={classes.wrapper}>
      <Box className={classes.card}>
        <Typography variant="h5" className={classes.title}>
          {t('empty-state.title')}
        </Typography>
        <Typography variant="body2" className={classes.description}>
          {t('empty-state.description', { term: searchTerm })}
        </Typography>
        <Typography variant="body2" className={classes.suggestion}>
          {t('empty-state.suggestion')}
        </Typography>
      </Box>
    </Box>
  )
}

export default EmptyState
